// Sources publiques consultées le 6 septembre 2026. Actualiser avant publication.
export const COMPARISON = [
  {
    "name": "Abeille Assurances",
    "type": "Offre BTP",
    "summary": "Responsabilité civile professionnelle et décennale présentées sur une page dédiée.",
    "check": "Vérifier les activités et garanties retenues dans votre proposition.",
    "url": "https://www.abeille-assurances.fr/assurance-professionnelle/mon-activite/responsabilite-civile/btp.html"
  },
  {
    "name": "Allianz",
    "type": "Offre BTP",
    "summary": "Assurances dédiées aux artisans du bâtiment, incluant la responsabilité décennale.",
    "check": "Demander le détail des garanties et options correspondant à votre activité.",
    "url": "https://www.allianz.fr/assurances-professionnels-entreprises/metiers/artisans-du-batiment.html"
  },
  {
    "name": "AXA",
    "type": "Garanties détaillées",
    "summary": "La page distingue notamment les travaux soumis et non soumis à assurance obligatoire.",
    "check": "Vérifier les conditions applicables à chaque catégorie de travaux déclarée.",
    "url": "https://www.axa.fr/professionnels/assurances-professionnelles/assurance-decennale/assurance-decennale-btp-garanties.html"
  },
  {
    "name": "Gan Assurances",
    "type": "Offre BTP",
    "summary": "Une page dédiée aux professionnels du bâtiment présente les besoins en décennale et dommages-ouvrage.",
    "check": "Distinguer la RC décennale du constructeur de la dommages-ouvrage du maître d’ouvrage.",
    "url": "https://www.gan.fr/page-daccueil/professionnels/assurer-mon-activite/assurances-professionnels-du-batiment/"
  },
  {
    "name": "Generali",
    "type": "Information générale",
    "summary": "Un article explique les assurances obligatoires et conseillées dans le BTP.",
    "check": "Cette source ne détaille pas une proposition contractuelle : demander la disponibilité et les conditions de l’offre.",
    "url": "https://www.generali.fr/professionnel/actu/btp-quelles-assurances/"
  },
  {
    "name": "GMF",
    "type": "Information générale",
    "summary": "La source traite des assurances d’une maison en construction, du point de vue du particulier.",
    "check": "Cette page ne confirme pas une offre RC décennale destinée aux artisans. Contacter GMF pour votre besoin professionnel.",
    "url": "https://www.gmf.fr/habitation-assurance-pret-immobilier/assurance-habitation/assurance-maison-construction"
  },
  {
    "name": "Groupama",
    "type": "Offre construction",
    "summary": "La multirisque construction présente la responsabilité décennale et d’autres garanties de responsabilité.",
    "check": "Comparer les garanties après travaux et leurs limites dans les documents contractuels.",
    "url": "https://www.groupama.fr/assurance-professionnels/conseils/responsabilite-civile-decennale/"
  },
  {
    "name": "MAAF",
    "type": "Offre BTP",
    "summary": "Présentation de la décennale dans l’environnement des assurances professionnelles du bâtiment.",
    "check": "Demander les conditions du contrat multirisque BTP et les activités inscrites sur l’attestation.",
    "url": "https://www.maaf.fr/fr/assurance-professionnelle/assurance-decennale"
  },
  {
    "name": "Macif",
    "type": "Offre RC décennale",
    "summary": "La page entreprise présente une franchise modulable et un tarif tenant compte du chiffre d’affaires.",
    "check": "Faire confirmer l’éligibilité de votre métier et le montant de franchise proposé.",
    "url": "https://www.macif.fr/assurance/professionnels-et-entreprises/responsabilite-civile-decennale-entreprise"
  },
  {
    "name": "MMA",
    "type": "Offre BTP",
    "summary": "La responsabilité décennale est présentée dans le contrat MMA BTP, avec des garanties complémentaires.",
    "check": "Vérifier quelles garanties complémentaires sont effectivement incluses dans votre devis.",
    "url": "https://entreprise.mma.fr/votre-activite/assurance-decennale.html"
  },
  {
    "name": "Orus",
    "type": "Courtage en ligne",
    "summary": "Orus se présente comme courtier et propose une assurance décennale en ligne.",
    "check": "Identifier la compagnie qui porte le risque et vérifier les conditions du contrat proposé.",
    "url": "https://www.orus.eu/"
  },
  {
    "name": "PRO BTP",
    "type": "Gamme artisans",
    "summary": "Le groupe présente une gamme pour les artisans du BTP comprenant une assurance décennale.",
    "check": "Identifier le contrat proposé et l’assureur porteur du risque sur les documents remis.",
    "url": "https://groupe.probtp.com/accueil/nos-metiers/assurances.html"
  },
  {
    "name": "SMABTP",
    "type": "Offre artisans et TPE",
    "summary": "La page présente une offre réunissant décennale, responsabilité civile et dommages en cours de travaux.",
    "check": "Vérifier les critères de l’offre artisans et TPE et les options nécessaires à vos chantiers.",
    "url": "https://www.smabtp.fr/sma/assurance/produits/assurance-activite-professionnelle-des-artisans-et-tpe-du-batiment-comptant-jusque-5-salaries?id=jyzhproda_6473"
  },
  {
    "name": "Swiss Life",
    "type": "Présentation de gamme",
    "summary": "Une page d’information mentionne la construction et la décennale parmi les solutions professionnelles.",
    "check": "Demander la documentation du contrat actuellement accessible pour votre activité.",
    "url": "https://www.swisslife.fr/particuliers/your-life-stories/assurance-de-biens.html"
  },
  {
    "name": "Thélem assurances",
    "type": "Information générale",
    "summary": "Un article présente les assurances utiles lors de la construction d’une maison.",
    "check": "Cette source ne précise pas les conditions d’une offre décennale artisan : disponibilité à confirmer auprès du réseau.",
    "url": "https://www.thelem-assurances.fr/actualite-assurance/habitation/quelles-assurances-avoir-lors-de-la-construction-dune-maison/"
  }
];
